module.exports = "<uch></uch>\r\n<head-title params='title:\"修改密码\"'></head-title>\r\n<div class=\"userContBottom\">\r\n    <div class=\"userContent\">\r\n        <div class=\"resetPasswordMiddle\" style=\"padding: 0;\">\r\n            <div class=\"resetPasswordContainer\">\r\n                <reset-password params=\"step:'update'\"></reset-password>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/resetPassword/updatePassword.html
// module id = 193
// module chunks = 0